import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'
import { getScoreValue } from '@/utils/getScoreRangeValue'
import { NOT_RATED_REASON } from '@/utils/reputationRating'
import { MAX_SCORE, getScoreTextClass } from '@/utils/scoreColors'
import type { Progress } from '../charts/threeStepProgress'

interface Props {
  score: number | null | undefined
  scoreRange?: Progress
  isNotRated?: boolean
  totalScorePenalty?: NonNullable<Vault['score']>['totalScorePenalty']
}

export function ReputationTooltipContent({ score, scoreRange, isNotRated = false, totalScorePenalty = 0 }: Props) {
  const textClass = scoreRange === undefined ? '' : getScoreTextClass(scoreRange)

  if (isNotRated) {
    return <p className="max-w-xs text-sm">{NOT_RATED_REASON}</p>
  }

  if (score == null) {
    return <p>Reputation score is unavailable for this vault</p>
  }

  return (
    <p className={totalScorePenalty > 0 ? 'text-base' : undefined}>
      {totalScorePenalty > 0 ? (
        <>
          <span className="font-medium text-button-foreground">{getScoreValue(score + totalScorePenalty)}</span>
          <span className="text-disabled">
            {' '}
            - <span className="font-medium">{getScoreValue(totalScorePenalty)}</span> (penalties)
          </span>
          {' = '}
        </>
      ) : (
        'Reputation score: '
      )}
      <span className={cn(totalScorePenalty > 0 ? 'font-medium' : 'font-bold', textClass)}>{getScoreValue(score)}</span>
      {' / '}
      <span className={totalScorePenalty > 0 ? 'text-button-foreground' : undefined}>{MAX_SCORE / 10}</span>
    </p>
  )
}
